module.exports = __webpack_public_path__ + "static/media/S (73).07ad9c1b.jpg";